import { j as i } from "./jsx-runtime-944c88e2.js";
import { Button as s } from "@chakra-ui/react";
import "react";
const c = ({ mpEventName: e = "BUTTON_CLICK", onClick: o, ...n }) => {
  const m = (r) => {
    const t = o;
    t != null && (t.name, t(r));
  };
  return /* @__PURE__ */ i.jsx(s, { ...n, onClick: m });
};
export {
  c as Button
};
